export default {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    loading: 'Loading...',
    success: 'Operation successful',
    error: 'Operation failed',
    networkError: 'Network error'
  },
  nav: {
    home: 'Home',
    card: 'Card',
    contacts: 'Contacts',
    chat: 'Chat',
    profile: 'Profile'
  },
  profile: {
    title: 'Profile',
    personalInfo: 'Personal Information',
    editProfile: 'Edit Profile',
    myCards: 'My Cards',
    myContacts: 'My Contacts',
    settings: 'Settings',
    logout: 'Logout',
    totalVisitors: 'Total Visitors',
    friendCount: 'Friends Count',
    todayVisitors: 'Today\'s Visitors',
    todayIncrement: 'Today\'s Increase'
  },
  settings: {
    accountSecurity: 'Account Security',
    notificationSettings: 'Notification Settings',
    languageSettings: 'Language Settings',
    logout: 'Logout',
    accountSecurityDesc: 'Change password, bind phone, etc.',
    notificationSettingsDesc: 'Manage message notification preferences',
    languageSettingsDesc: 'Select app language',
    logoutDesc: 'Safely log out of current account'
  },
  language: {
    title: 'Language Settings',
    selectLanguage: 'Select Language',
    zhCN: 'Chinese (Simplified)',
    enUS: 'English',
    jaJP: 'Japanese',
    koKR: 'Korean',
    ruRU: 'Russian'
  },
  contact: {
    sameLevel: 'Same Level Contacts',
    higherLevel: 'Higher Level Contacts',
    goldMember: 'Gold Member',
    platinumMember: 'Platinum Member',
    diamondMember: 'Diamond Member',
    unlock: 'Unlock',
    contact: 'Contact',
    unlockContact: 'Unlock Contact',
    upgradeForContacts: 'Upgrade membership to unlock more contacts'
  },
  storage: {
    basicPlan: 'Basic Plan',
    professionalPlan: 'Professional Plan',
    enterprisePlan: 'Enterprise Plan',
    month: 'Month',
    features: {
      basic: ['50GB Storage', 'Basic Security', 'File Sharing'],
      professional: ['200GB Storage', 'Advanced Security Encryption', 'Team Collaboration', 'Priority Customer Service'],
      enterprise: ['1TB Storage', 'Enterprise-level Security', 'Unlimited Collaboration', 'Dedicated Customer Service']
    },
    buyStorage: 'Buy Storage',
    buyPlan: 'Buy Plan',
    uploadFile: 'Upload File',
    viewFiles: 'View Files',
    downloadAll: 'Batch Download',
    documents: 'Documents',
    images: 'Images',
    videos: 'Videos',
    others: 'Others'
  },
  menu: {
    myCards: 'My Cards',
    myCardsDesc: 'Manage my digital cards',
    memberCenter: 'Member Center',
    memberCenterDesc: 'Upgrade membership for more benefits',
    myFavorites: 'My Favorites',
    myFavoritesDesc: 'View saved content',
    myRelations: 'My Relations',
    myRelationsDesc: 'Manage social relationships',
    chat: 'Chat & Socialize',
    chatDesc: 'Chat and interact with friends',
    contacts: 'Contacts',
    contactsDesc: 'Manage contacts',
    privacy: 'Privacy Settings',
    privacyDesc: 'Manage privacy permissions'
  }
}
